// extracted by mini-css-extract-plugin
export default {"manage-button__mobile":"ManageButton_manage-button__mobile__nxqp9"};